export const isFetchingKeywordResearch = (state, keyword, seoDb) => {
  const researchType = state["keyword_research"]["selected_research_type"];
  const hKey = `${researchType}:${seoDb}`;
  return state["keyword_research"]["network_activity"].includes(`fetch_keyword_research_${keyword}:${hKey}`);
};

export const getKeywordResearchData = state => state["keyword_research"]["data"];

export const getKeywordResearch = (state, keyword, seoDb) => {
  const researchType = state["keyword_research"]["selected_research_type"];
  const hKey = `${researchType}:${seoDb}`;
  let keywordResearch = state["keyword_research"]["data"];
  if (keywordResearch[keyword] && keywordResearch[keyword][hKey]) {
    return keywordResearch[keyword][hKey];
  }
  return {};
};

export const getKeywordResearchKeywords = (state, keyword, seoDb) => {
  let keywordResearch = getKeywordResearch(state, keyword, seoDb);
  if ("keywords" in keywordResearch) {
    return keywordResearch["keywords"];
  }
  return [];
};

export const getKeywordResearchHasMore = (state, keyword, seoDb) => {
  let keywordResearch = getKeywordResearch(state, keyword, seoDb);
  return keywordResearch["has_more"];
};

export const isFirstFetch = (state, keyword, seoDb) => {
  return isFetchingKeywordResearch(state, keyword, seoDb) && getOffset(state, keyword, seoDb) === 0;
};

export const getOffset = (state, keyword, seoDb) => {
  return getKeywordResearchKeywords(state, keyword, seoDb).length;
};

export const getSelectedResearchType = state => state["keyword_research"]["selected_research_type"];

export const getDefaultResearchType = state => state["keyword_research"]["research_types"][0]["key"];

export const getResearchTypes = state => state["keyword_research"]["research_types"];

export const getDefaultSeoDb = state => state["keyword_research"]["default_seo_db"];

export const getKeywordResearchTitle = state => state["keyword_research"]["title"];
